import {
  GET_AGENT,
  GET_AGENT_SUCCESS,
  GET_AGENT_FAIL,
  DELETE_AGENT,
  DELETE_AGENT_SUCCESS,
  DELETE_AGENT_FAIL,
  UPDATE_AGENT,
  UPDATE_AGENT_SUCCESS,
  UPDATE_AGENT_FAIL,
  ADD_NEW_AGENT,
  ADD_AGENT_SUCCESS,
  ADD_AGENT_FAIL,
  AGENT_LOADING,
  AGENT_RESET,
  AGENT_RESET_CREATE
} from "./actionType";

export const resetAgentState = (actionType) => ({
  type: AGENT_RESET,
  payload: { actionType },
});


export const resetAgentCreateState = (actionType) => ({
  type: AGENT_RESET_CREATE,
  payload: { actionType }
});

export const getAgentSuccess = (actionType, data) => ({
  type: GET_AGENT_SUCCESS,
  payload: { actionType, data },
});

export const getAgentFail = (actionType, error) => ({
  type: GET_AGENT_FAIL,
  payload: { actionType, error },
});

export const getAgent = data => ({
  type: GET_AGENT,
  payload: data,
});

export const getAgentLoading = () => ({
  type: AGENT_LOADING
});

export const deleteAgent = data => ({
  type: DELETE_AGENT,
  payload: data,
});

export const deleteAgentSuccess = data => ({
  type: DELETE_AGENT_SUCCESS,
  payload: data,
});

export const deleteAgentFail = error => ({
  type: DELETE_AGENT_FAIL,
  payload: error,
});

export const updateAgent = data => ({
  type: UPDATE_AGENT,
  payload: data,
});

export const updateAgentFail = error => ({
  type: UPDATE_AGENT_FAIL,
  payload: error,
});

export const updateAgentSuccess = data => ({
  type: UPDATE_AGENT_SUCCESS,
  payload: data,
});

export const addNewAgent = data => ({
  type: ADD_NEW_AGENT,
  payload: data,
});

export const addAgentSuccess = data => ({
  type: ADD_AGENT_SUCCESS,
  payload: data,
});

export const addAgentFail = error => ({
  type: ADD_AGENT_FAIL,
  payload: error,
});